import type { RefObject } from "preact";
import { useLayoutEffect, useRef } from "preact/hooks";

// A textarea that is as tall as its text: the stylesheet gives the floor
// (min-height) and the ceiling (max-height — past it the text scrolls inside);
// this sets the height between them whenever `value` changes, before paint,
// so typing, pasting and the programmatic clear on send all resize it. The
// textarea takes rows={1}: with the height left to the content, the rows
// attribute (two by default) is the empty box's height, not the stylesheet.

export function useAutogrow(value: string): RefObject<HTMLTextAreaElement> {
  const ref = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    // scrollHeight is content + padding; the box is border-box, so add the border back.
    el.style.height = `${el.scrollHeight + el.offsetHeight - el.clientHeight}px`;
  }, [value]);
  return ref;
}
